class customGWPJS {
    constructor() {
      this.cartElement = document.querySelector('cart-form'); 
      this.gwp_info_msg = document.querySelector('[data-gwp-info]') || null;
      this.parentContainer = document.querySelector('[data-gwpHTML]') || null;
      this.GWP = JSON.parse(document.querySelector('[data-GWP-schema]').innerHTML);
      this.freeGifts = [];
      this.giftsInCart = {};
      if(this.parentContainer == null) return;

      if(this.GWP.gwp_pro1 != null){
        this.freeGifts.push(this.GWP.gwp_pro1);
        this.giftsInCart[this.GWP.gwp_pro1.id] = false;
      }
      if(this.GWP.gwp_pro2 != null){
        this.freeGifts.push(this.GWP.gwp_pro2);
        this.giftsInCart[this.GWP.gwp_pro2.id] = false;
      }

      this.checkForGifts();
    }

    checkForGifts() {
      const cartJSON = window.globalVariables.cart;
      const finalQtyArray = [];
      let updateGiftFound = false;
      let freeProductFound = false;
      
      cartJSON.items.forEach((item) => {
        if(item.properties && item.properties['_product_type'] == 'gift'){
          freeProductFound = true;
          if(this.giftsInCart[item.product_id] == undefined || cartJSON.total_price < this.GWP.amount){
            updateGiftFound = true; finalQtyArray.push(0);
          }else if(item.quantity > 1){
            updateGiftFound = true; finalQtyArray.push(1);
          }else{
            this.giftsInCart[item.product_id] = true;
            finalQtyArray.push(item.quantity);
          }
        }else{
          finalQtyArray.push(item.quantity);
        }
      });

      let leftAmount = this.GWP.amount - cartJSON.total_price;
      if(this.gwp_info_msg) this.gwp_info_msg.querySelector('.left-amount').innerHTML = Utility.formatMoney(leftAmount, window.globalVariables.money_format);
      
      if(updateGiftFound){
        this.bindUpdateEvent(finalQtyArray);
        this.parentContainer.innerHTML = '';
        [this.parentContainer, this.gwp_info_msg].forEach((ele) => {
          if(ele) ele.classList.add('d-none')
        });
      }else if(cartJSON.total_price >= this.GWP.amount && freeProductFound == false){
        this.buildUI();
        if(this.gwp_info_msg) this.gwp_info_msg.classList.add('gwp-success', 'd-none');
      }else{
        this.parentContainer.innerHTML = '';
        [this.parentContainer, this.gwp_info_msg].forEach((ele) => {
          if(ele) ele.classList.add('d-none')
        });
        if(this.gwp_info_msg && cartJSON.total_price < this.GWP.amount) this.gwp_info_msg.classList.remove('gwp-success', 'd-none');
      }        
    }

    buildUI(){
      let gwpHTML = `<div class="row mx-md-n3 mx-n2 cart-item pb-6 pb-md-6 pt-4 border-bottom">
        <div class="col-12  px-md-3 px-2 gift_prod_heading">
          <div class="general-text mb-4 mb-md-5 text-center h5 font-family-base">Congratulations! You’ve qualified for a free gift with your purchase!</div>
        </div>
      `;
      this.freeGifts.forEach((product)=>{
        let giftAdded = this.giftsInCart[product.id];
        let actionButton = null;
        let addText = (window.globalVariables.template == 'cart') ? "Add to cart" : "Add";
        let addedText = (window.globalVariables.template == 'cart') ? "Added to cart" : "Added";
        if(product.available == false){
          actionButton = ` <button type="button" class="btn btn-primary btn-sm add-to-cart disabled" disabled">
          <span>Sold Out</span>
        </button>`;
        }else{
          actionButton = ` <button type="button" name="add" class="btn btn-primary btn-sm add-to-cart ${(giftAdded) ? 'disabled' : '' }" ${(giftAdded) ? 'disabled' : '' } data-addID="${product.variants[0].id}" data-addFreeItem>
            <span>${giftAdded ? addedText : addText }</span>
          </button>`;
        }
        let productUI = `<div class="col-6 px-md-3 px-2 mb-3 mb-md-0 cart-product-img">
        <div class="border overflow-hidden min-h-100 d-flex">
          <div class="row no-gutter gwp-product min-h-100">
              <div class="cart-img col-md-4">
                <img class="gift_img" src="${product.featured_image}" loading="lazy" width="75" height="95" />
              </div>
              <div class="cart-item-text col-md-8 px-md-3 pb-3 pt-2 d-flex align-items-center">
                <div class="px-md-0 px-2">
                  <p class="card-title fw-medium">${product.title}</p>
                  <div class="cart-price">
                      <span class="orgi_price ajaxcart__price">FREE | <del>${Utility.formatMoney(product.compare_at_price, window.globalVariables.money_format)}</del></span>
                  </div>
                  <div class="quantity-box mt-3">
                      ${actionButton}
                  </div>
                </div>  
              </div>
          </div>
        </div>  
        </div>`;
        gwpHTML += productUI;
      });
      gwpHTML += `</div>`

      this.parentContainer.innerHTML = gwpHTML;
      this.parentContainer.classList.remove('d-none');

      let atcBtns = document.querySelectorAll('[data-addFreeItem]');
      atcBtns.forEach((btn) => btn.addEventListener('click', this.bindATCEvent.bind(this)));
    }

    bindATCEvent(event){
      let targetBtn = event.currentTarget;
      let varID = targetBtn.dataset.addid;
      if(varID == undefined) return;

      targetBtn.setAttribute('disabled', true);
      this.parentContainer.classList.add('loading');

      let properties = {
        _product_type: 'gift',
        _spend_over: this.GWP.amount / 100
      }
      let data = [{
        id: varID,
        quantity: 1,
        properties: properties
      }];

      this.cartAction('add', data).then(response => {
        if(typeof response == 'object' && response.items){
          if(this.cartElement){
            this.cartElement._updateCart(response.sections);
            this.parentContainer.classList.remove('loading');
          }else{
            window.location.href = window.routes.cart_fetch_url;
          } 
        }else{
          window.notificationEle.updateNotification('Something went wrong!', response.errors, {
            type: 'error',
            timeout: 5000
          });
        }
      }); 
    }

    bindUpdateEvent(data){
      this.cartAction('update', data).then(response => {
        if(typeof response == 'object' && response.items){
          if(this.cartElement){
            this.cartElement._updateCart(response.sections);
          }else{
            window.location.href = window.routes.cart_fetch_url;
          } 
        }else{
          window.notificationEle.updateNotification('Something went wrong!', response.errors, {
            type: 'error',
            timeout: 5000
          });
        }
      }); 
    }

    /**
     * Add free gift / Update cart if has any free gift issue
     *
     * @param {string} action Operation to perform
     * @param {object} item object for cart add/update operation
     */
    async cartAction(action, item) {
      let cartSection = document.getElementById('cart--items').dataset.id || 'template-cart';
      let actionURL = window.routes.cart_add_url
      let data = { 
        items: item, 
        sections: `${cartSection},header`
      }

      if(action == 'update'){
        actionURL = window.routes.cart_update_url
        data = { 
          updates: item,
          sections: `${cartSection},header`
        }
      }
      
      return await fetch(actionURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "Accept": "application/json"
        },
        body: JSON.stringify(data)
      })
      .then((response)=>response.json())
      .then(responseJson => { return responseJson })
      .catch((error) => { return error; });
    }
}

typeof customGWPJS !== 'undefined' && new customGWPJS();


